{
  "it": {
    "fleetDashboard": {
      "showAll": "Mostra tutto",
      "empty": "Ancora niente qui.",
      "failed": "Al momento non è stato possibile caricarlo.",
      "unnamed": "Senza titolo",
      "formats": {
        "weekday": "EEE",
        "day": "d"
      },
      "activity": {
        "title": "Ultimi aggiornamenti",
        "you": "Tu",
        "kinds": {
          "member_joined": "Si è unito alla flotta",
          "event_published": "Evento pubblicato",
          "event_cancelled": "Evento annullato",
          "contract_published": "Contratto pubblicato",
          "contract_claimed": "Contratto preso in carico",
          "contract_fulfilled": "Contratto completato",
          "inventory_transfer_completed": "Trasferimento completato",
          "inventory_item_deposited": "Depositato",
          "inventory_item_withdrawn": "Prelevato"
        },
        "empty": {
          "title": "Non è ancora successo niente",
          "hint": "Qui arrivano gli eventi e i contratti pubblicati, i più recenti per primi."
        }
      },
      "events": {
        "title": "Prossimi eventi",
        "signUp": "Iscriviti",
        "empty": {
          "title": "Niente in programma nelle prossime due settimane",
          "hint": "Controlla la pagina degli eventi per quelli più avanti.",
          "hintCreate": "Metti un'operazione in calendario e i membri potranno iscriversi subito.",
          "action": "Pianifica un evento"
        }
      },
      "actionQueue": {
        "title": "Richiede la tua attenzione",
        "joinRequests": {
          "one": "%{count} richiesta di adesione",
          "other": "%{count} richieste di adesione"
        },
        "pendingTransfers": {
          "one": "%{count} trasferimento in entrata da gestire",
          "other": "%{count} trasferimenti in entrata da gestire"
        },
        "partFailed": "Al momento non è stato possibile caricare una parte di ciò che ti aspetta.",
        "empty": {
          "title": "Tutto in ordine",
          "hint": "Qui compaiono le richieste di adesione e i trasferimenti in arrivo che aspettano una risposta."
        },
        "memberHealth": {
          "one": "%{count} controllo dell'organico richiede attenzione",
          "other": "%{count} controlli dell'organico richiedono attenzione"
        }
      },
      "contracts": {
        "title": "Contratti",
        "mine": "Il tuo lavoro",
        "open": "Disponibili",
        "partFailed": "Al momento non è stato possibile caricare alcuni contratti.",
        "empty": {
          "title": "Nessun contratto aperto",
          "hint": "Sfoglia i lavori passati nella bacheca dei contratti.",
          "hintCreate": "Pubblica un lavoro che i membri possono prendere in carico.",
          "action": "Pubblica un contratto"
        }
      },
      "inventory": {
        "title": "Inventario",
        "empty": "Nessun movimento di inventario di recente.",
        "emptyMine": "Di recente non si è mosso nulla di tuo.",
        "emptyHint": "Qui compaiono depositi, prelievi e trasferimenti.",
        "mine": "Miei",
        "fleet": "Flotta"
      },
      "newMembers": {
        "title": "Nuovi membri",
        "empty": {
          "title": "Nessun nuovo arrivo di recente",
          "hint": "I membri compaiono qui non appena si uniscono."
        }
      },
      "about": {
        "title": "Informazioni sulla flotta",
        "empty": {
          "title": "Ancora nessuna descrizione",
          "hint": "La flotta non si è ancora presentata.",
          "hintEdit": "Racconta ai nuovi membri di cosa si occupa la flotta.",
          "action": "Scrivine una"
        }
      },
      "week": {
        "emptyDay": "Niente in programma il %{day}."
      },
      "online": {
        "title": "Online ora (%{count})",
        "titlePending": "Online ora",
        "friend": "Amico",
        "more": {
          "one": "e altri %{count}",
          "other": "e altri %{count}"
        },
        "empty": {
          "title": "Nessun altro è online",
          "hint": "I membri compaiono qui non appena accedono."
        }
      },
      "announcements": {
        "post": "Pubblica un annuncio",
        "postAction": "Pubblica",
        "edit": "Modifica annuncio",
        "body": "Annuncio",
        "until": "fino al %{date}",
        "confirmRemove": "Rimuovere questo annuncio per tutti?",
        "expiry": {
          "label": "Mostralo",
          "keep": "Mantieni la scadenza attuale",
          "never": "Finché non viene rimosso",
          "day": "Per un giorno",
          "days3": "Per tre giorni",
          "week": "Per una settimana",
          "weeks2": "Per due settimane"
        },
        "messages": {
          "saved": "Annuncio salvato.",
          "saveFailed": "Impossibile salvare l'annuncio.",
          "removed": "Annuncio rimosso.",
          "removeFailed": "Impossibile rimuovere l'annuncio."
        },
        "more": {
          "one": "Mostra %{count} altro annuncio",
          "other": "Mostra altri %{count} annunci"
        }
      }
    }
  }
}
